import { withAsyncEnterLoader, withLoader } from 'util/routeHelper';
import { getUserOverview } from 'actions/user';

export default store => ({
	path: 'overview',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'overview',
				),
			store,
			'OVERVIEW',
		),
		onEnter: withAsyncEnterLoader(
			async (_, __, updateRatio) => {
				await store.dispatch(getUserOverview());
				updateRatio(0.8);
			},
			store,
			'ENTER_OVERVIEW',
		),
	},
});



// WEBPACK FOOTER //
// ./src/routes/User/Overview/index.js